import React from 'react';

interface HilProgressBarProps {
  current: number;
  total: number;
}

export function HilProgressBar({ current, total }: HilProgressBarProps): React.JSX.Element | null {
  if (total <= 1) return null;
  const pct = Math.min(100, Math.round((current / total) * 100));
  return (
    <div className="hil-progress-bar">
      <div className="hil-progress-track">
        <div className="hil-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="hil-progress-label">Step {current} of {total}</span>
    </div>
  );
}
